// src/components/Dashboard/Dashboard.js
import React from 'react';
import TransportMap from '../TransportMap/TransportMap';
import './Dashboard.css';

const Dashboard = () => {
  return (
      <div className="dashboard">
        <div className="dashboard-content">
          <TransportMap />
        </div>
      </div>
  );
};

export default Dashboard;


/* Old Code
*/